<template>
  <section class="content-main mt-20 mb-40">
    <div class="card mx-auto card-login">
      <div class="card-body">
        <div class="text-center mb-4">
          <img
            src="../../../assets/imgs/logo.svg"
            class="logo"
            alt="E-Commerce Admin Panel"
          />
        </div>
        <a-form
          id="components-form-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >
          <a-form-item>
            <a-input
              size="large"
              v-decorator="[
                'mobile',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your mobile number',
                    },
                  ],
                },
              ]"
              placeholder="Mobile Number"
            >
              <!-- <span slot="addonBefore">
                +88
              </span> -->
              <a-icon slot="prefix" type="mobile" style="color: rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'Please input your Password!' },
                  ],
                },
              ]"
              type="password"
              placeholder="Password"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>

          <a-form-item>
            <router-link class="login-form-forgot" to="/auth/forget-password">
              {{ $t("common.forget_password") }}
            </router-link>
            <a-button
              size="large"
              type="primary"
              html-type="submit"
              class="btn btn-xs login-form-button"
            >
              {{ $t("common.login") }}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </section>
</template>

<script>
// import {SIGN_IN} from "../../../script/api";
import { login } from "../../../script/api-service";
import * as CryptoJS from "crypto-js";
import * as Cookies from "js-cookie";
import { checkRes, alertPop } from "../../../script/helper";
import moment from "moment";

export default {
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields(async (err, values) => {
        if (!err) {
          let data = values;

          data.fcm_token = localStorage.getItem("fcmlogistic-token") || null;
          data.device_os = "web";

          console.log("data", data);

          let res = await login(data);

          if (checkRes(res?.data?.code || res.code)) {
            let token = CryptoJS.AES.encrypt(
              res.data.data.token,
              "$%sslWireless$$_logita_revamp_fe%$"
            );

            // new Date(new Date().getTime() + 15 * 60 * 1000); here 15 is the min value;
            var sixtymin = moment().add(res?.data?.data?.expires_in || 3600, 'seconds').toDate(); //new Date(new Date().getTime() + 60 * 60 * 1000);
            Cookies.set("token", token, { expires: sixtymin});

            sessionStorage.setItem("logistic-userinfo-permission", JSON.stringify(res.data.data.user?.roles[0]?.permissions));
            window.location = "/";
          } else {
            if (res?.data?.messages?.length) {
                res?.data?.messages.forEach(messsage => {
                  alertPop("error", messsage);
                });
            } else {
              alertPop("error", "Something went wrong!");
            }
          }
        }
      });
    },
  },
};
</script>

<style>
#components-form-normal-login .login-form {
  max-width: 300px;
}
#components-form-normal-login .login-form-forgot {
  float: right;
  color: #088178;
}
#components-form-normal-login .login-form-button {
  width: 100%;
}
</style>
